import { Honeybadger } from '@honeybadger-io/react';

import { requestApi } from 'api/Api';

import { showAlert } from 'components/shared/Alert/Alert';

export function billingProviders({ queryClient, navigate, setShowModal, setIsDeleting }) {
  const submitBillingProvider = async (values, formikHelpers = {}) => {
    const { setSubmitting = () => {} } = formikHelpers;

    try {
      const newBillingProvider = {
        ...values,
        bill_taxid_type: values.bill_taxid_type?.value
      };

      const res = await requestApi({
        url: '/api/admin/practice/billing/upsert',
        params: { newBillingProvider },
        navigate
      });

      if (res?.success) {
        showAlert({ title: 'Success!', color: 'primary' });
        queryClient.invalidateQueries(['billing-provider']);
      } else {
        Honeybadger.notify('billingProviders → submitBillingProvider: unexpected error');
        showAlert({ title: 'There was an error.', color: 'danger' });
      }
    } catch (error) {
      Honeybadger.notify(`billingProviders → submitBillingProvider: ${error}`);
    } finally {
      setSubmitting(false);
    }
  };

  const handleDeletion = async (id) => {
    setIsDeleting(true);
    try {
      const res = await requestApi({
        url: '/api/admin/practice/billing/delete',
        params: { id },
        navigate
      });

      if (res?.success) {
        showAlert({ title: 'Successfully deleted!', color: 'primary' });
        queryClient.invalidateQueries(['billing-provider']);
        setShowModal(false);
      } else {
        Honeybadger.notify('billingProviders → handleDeletion: unexpected error');
        showAlert({ title: 'There was an error deleting', color: 'danger' });
      }
    } catch (error) {
      Honeybadger.notify(`billingProviders → handleDeletion: ${error}`);
    }
    setIsDeleting(false);
  };

  return {
    submitBillingProvider,
    handleDeletion
  };
}
